import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { MatButtonModule } from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule, Routes } from '@angular/router';

import { CultureAuditComponent } from './culture-audit.component';
import { BarraProgresoComponent } from './barra-progreso/barra-progreso.component';
import { ContdemoComponent } from './contdemo/contdemo.component';

const rutas: Routes = [
    {
        path     : 'cultureaudit',
        component: CultureAuditComponent
    },
];

@NgModule({
  declarations: [CultureAuditComponent, BarraProgresoComponent, ContdemoComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FuseSharedModule,
    FuseSidebarModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    TranslateModule
  ]
})
export class CultureAuditModule { }
